export const billingSupplyAuthorizationColumns = [
  { label: 'Status', value: 'status' },
  { label: 'Fatura', value: 'number' },
  { label: 'Empresa', value: 'client' },
  { label: 'N do Empenho contábil', value: 'allocation_accounting_number' },
  { label: 'Cons. na fatura', value: 'total_amount', className: 'text-yellow-400' },
  { label: 'Vlr. da AF', value: 'amount', className: 'text-valid' },
  { label: 'Dt. Abertura da fatura', value: 'opened_at' },
  { label: 'Dt. Fechamento da fatura', value: 'closed_at' },
  { label: 'Autor', value: 'author' },
  { label: 'Data de envio', value: 'created_at' },
  { label: 'Ações', value: 'actions', className: 'w-0' },
]
